import { queryOptions } from '@tanstack/react-query';
import { api } from '@/api/api';

export const leaveKeys = {
  all: ['leaves'] as const,
  byUser: (userId: string) => [...leaveKeys.all, userId] as const,
  byProject: (projectId: string) => [...leaveKeys.all, 'project', projectId] as const,
  summary: (userId: string, year: number) => [...leaveKeys.all, 'summary', userId, year] as const,
};

export const leavesByUserOptions = (userId: string) =>
  queryOptions({
    queryKey: leaveKeys.byUser(userId),
    queryFn: () => api.listLeaves(userId),
    staleTime: 60_000,
  });

export const leavesByProjectOptions = (projectId: string) =>
  queryOptions({
    queryKey: leaveKeys.byProject(projectId),
    queryFn: () => api.listProjectLeaves(projectId),
    staleTime: 60_000,
  });

export const leaveSummaryOptions = (userId: string, year: number) =>
  queryOptions({
    queryKey: leaveKeys.summary(userId, year),
    queryFn: () => api.getLeaveSummary(userId, year),
    staleTime: 60_000,
  });
